module.exports = __webpack_public_path__ + "img/logo.a79786bf.png";